import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { AgRendererComponent } from '@ag-grid-community/angular';
import { EMailService } from '../../services/email.service';
import { EDeliveryService } from '../../services/edelivery.service';
import { WarningService } from '../../services/warning.service';
import { Email } from '../../models/e-mail.model';
import { Warning } from '../../models/warning.model';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { DocsIncluded } from '../../models/docs-included.model';
import { Account } from '../../models/account.model';
import { Subscription } from 'rxjs';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'grid-documents-cell',
    templateUrl: './grid-documents-cell.component.html',
    styleUrls: ['./grid-documents-cell.component.css'],
    encapsulation: ViewEncapsulation.None
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridDocumentsCellComponent implements AgRendererComponent, OnDestroy {

    // @Input()
    // preferencesData: string;

    // @Input()
    // isEdit: boolean; // Needed for small template reference

    // @Input()
    // isMobile: boolean;

    @Input('preferencesData') preferencesData: Account;
    @Input('isEdit') isEdit: boolean;
    @Input('isGridDisp') isGridDisp: boolean;

    aCounter: number = 0;
    private params: any;
    private preferencesSavedSubscription: Subscription;
    private proxyWarningSubcription: Subscription;
    private docsIncludedSubscription: Subscription;
    warning: Warning;
    accountEmails: any;
    userEmails: Email[] = [];
    listOfEnrolledDocuments: string[] = [];
    pershingDocNames: string[] = [];
    albridgeDocNames: string[] = [];

    externalEmailAddress: string;
    originalEmailAddress: string;
    isEmailPartOfEmailsList: boolean = true;
    emailChanged: boolean = false;
    originalAccount: Account;
    pendingAccount: Account;
    displayWarning: boolean = false;
    warningMessage: string;

    allDocumentNames: any;
    testAccount: any;
    isMain: boolean = true;
    selectedEmail = '';
    proxyChecked = false;
    prospectusChecked = false;
    displayProspectus = false;
    disableEmail = true;
    testCount: number = 0;
    myEvent: any;
    hide = true;
    docsIncluded: DocsIncluded[] = [];
    showDocsIncluded = false;
    preferencesChangedForAccount = false;
    isNXIRequest = false;

    // Labels
    includedLabel = EdeliveryLabels.INCLUDED;
    includedTitle = EdeliveryLabels.INCLUDED_TITLE;
    seeAllLabel = EdeliveryLabels.SEE_ALL;
    seeAllTitle = EdeliveryLabels.SEE_ALL_TITLE;
    noDocumentsSetupLabel = EdeliveryLabels.NO_DOCUMENTS_SETUP;
    proxyInfo = EdeliveryLabels.PROXY_INFO;
    emailInfoTooltip = EdeliveryLabels.EMAIL_INFO_TOOLTIP;
    closeLabel = EdeliveryLabels.CLOSE;
    notificationsPopupDetail = EdeliveryLabels.NOTICATIONS_POPUP_DETAIL_TEXT

    // Document names labels
    statementsLabel = EdeliveryLabels.STATEMENTS;
    tradeLabel = EdeliveryLabels.TRADE;
    QPRLabel = EdeliveryLabels.QPR;
    notificationsLabel = EdeliveryLabels.NOTIFICATIONS;
    taxLabel = EdeliveryLabels.TAX;
    prospectusLabel = EdeliveryLabels.PROSPECTUS;
    proxyLabel = EdeliveryLabels.PROXY;
    
    constructor(private emailService: EMailService, private eDeliveryService: EDeliveryService, private warningService: WarningService,
                private translate: PershingTranslationService ) {
        console.log('grid-documents cell preferencesData is ', this.preferencesData);
        console.log('isEdit is ', this.isEdit);
        this.preferencesSavedSubscription = this.eDeliveryService.preferencesSaved$.subscribe(response => {
            if (response) {
                console.log('isEdit is ', this.isEdit);
                if (this.isEdit === undefined ) {
                    this.eDeliveryService.preferencesConfirmed(true);
                } else if (this.isEdit ) {
                    this.eDeliveryService.preferencesConfirmedMobile(true);
                }
            }
        });
        this.isNXIRequest = this.eDeliveryService.isNXIRequest();

        if (this.translate) {
            this.translate.addTranslationFolder('@pershing/edc-newedelivery', 'node_modules/@pershing/edc-newedelivery/lib');
        }
    }

    ngOnInit() {
        console.log('grid-documents cell preferencesData is ', this.preferencesData);
        if (this.isGridDisp) {
            this.agInit(this.preferencesData);
        }
        // this.agInit(this.preferencesData);
        console.log('isEdit is ', this.isEdit);
    }

    ngOnDestroy() {
        if (this.preferencesSavedSubscription) {
            this.preferencesSavedSubscription.unsubscribe();
        }
        if (this.proxyWarningSubcription) {
            this.proxyWarningSubcription.unsubscribe();
        }
        if (this.docsIncludedSubscription) {
            this.docsIncludedSubscription.unsubscribe();
        }
    }

    agInit(params: any): void {
        if (this.preferencesData !== undefined) {
            this.initialize(this.preferencesData);
        } else {
            this.initialize(params);
        }
    }

    initialize(params: any) {
        if (params.value !== undefined) { // Needed to determine whether to show for mobile/small frame vs large frame
            // this.params = JSON.parse(JSON.stringify(params.value));
            this.params = params.value;
        } else {
            // this.params = JSON.parse(JSON.stringify(params));
            this.params = params;
        }
        this.originalAccount = JSON.parse(JSON.stringify(this.params));
        this.warning = new Warning('');
        this.displayWarning = false;
        this.warningMessage = '';
        this.accountEmails = this.params.acctEmails;
        this.userEmails = this.emailService.getUserEmails();
        this.externalEmailAddress = this.params.externalEmailAddr;
        this.selectedEmail = this.params.externalEmailAddr;
        if ((this.selectedEmail === '' || this.selectedEmail === null) && this.userEmails.length > 0) {
            this.selectedEmail = this.userEmails[0].emailAddress;
        }
        this.originalEmailAddress = JSON.parse(JSON.stringify(this.params.externalEmailAddr));
        let tempisEmailPartOfEmailsList = false;
        for (let i = 0; i < this.userEmails.length; i++) {
            if (this.userEmails[i].emailAddress === this.originalEmailAddress) {
                tempisEmailPartOfEmailsList = true;
            }
        }
        if (tempisEmailPartOfEmailsList === false) {
            this.isEmailPartOfEmailsList = false;
        }

        this.proxyWarningSubcription = this.warningService.proxyWarning$.subscribe(warning => {
            // console.log('warning subscription getting called');
            if (warning) {
                this.warning.warningMessage = warning.warningMessage;
            }
        });

        this.docsIncludedSubscription = this.eDeliveryService.docsIncludedResponse$.subscribe(docsIncluded => {
            if (docsIncluded) {
                this.docsIncluded = docsIncluded.response;
            }
        });
        // this.allDocumentNames = ['Statements and Reports', 'Trade Confirmations', 'Notifications', 'Tax Documents', 'Quarterly Performance Reports'];
        this.allDocumentNames = [this.statementsLabel, this.tradeLabel, this.notificationsLabel, this.taxLabel, this.QPRLabel];

        this.backButtonCases();
        this.createListOfDocuments();

        if (params.column !== undefined && params.column.colDef.displayType === 'edit') {
            this.isMain = false;
        }
        if (this.isEdit !== undefined && this.isEdit === true) {
            this.isMain = false;
        }
        if (this.params.edeliveryDocuments[6] && this.params.edeliveryDocuments[6].docEligible === true) {
            this.displayProspectus = true;
        }
        this.isProxyChecked();
        this.isProspectusChecked();
        this.isEmailDisabled();
        this.isAccountPendingEnrollment();
        this.enableOrDisableSaveButton();
        // Assign email to service email so that enroll.component.ts has the correct info.
        this.eDeliveryService.externalEmail = this.selectedEmail;
    }

    refresh(params: any): boolean {
        return false;
    }

    superscript1Available(document) {
        let correctDocumentName = this.returnCorrespondingName(document);
        if (correctDocumentName === 'Notifications' || correctDocumentName === 'Tax Documents' || correctDocumentName === 'Quarterly Performance Reports' || correctDocumentName === 'Prospectus') {
            return true;
        }
    }

    superscript2Available(document) {
        let correctDocumentName = this.returnCorrespondingName(document);
        if (correctDocumentName === 'Quarterly Performance Reports') {
            return true;
        }
    }

    backButtonCases() {
        // Find docs that were enabled in previous state from preferences:
        if (this.eDeliveryService.backButtonClicked) {
            if (this.eDeliveryService.isMobile) {
                this.eDeliveryService.firstCellAccount = false;
            }
            if (!this.eDeliveryService.firstCellAccount) { // Needed because of weird grid behaviour with cells rendering one more time.
                for (let i = 0; i < this.eDeliveryService.stateCopyOfAccounts.length; i++) {
                    if (this.eDeliveryService.stateCopyOfAccounts[i].accountNumber === this.params.accountNumber) {
                        for (let j = 0; j < this.eDeliveryService.stateCopyOfAccounts[i].edeliveryDocuments.length; j++) {
                            let docNew = this.eDeliveryService.stateCopyOfAccounts[i].edeliveryDocuments[j];
                            let docPrevious = this.params.edeliveryDocuments[j];
                            if ((docNew.preferenceType.deliveryPreference !== docPrevious.preferenceType.deliveryPreference) ||
                                 docPrevious.preferenceType.deliveryPreference === 4) {
                                let myEvent;
                                if (docNew.preferenceType.deliveryPreference === 2 || docNew.preferenceType.deliveryPreference === 4) {
                                    myEvent = {checked: true};
                                } else {
                                    myEvent = {checked: false};
                                }
                                if (docNew.edocumentType.docTypeCd === 'PRXY') {
                                    this.selectedEmail = this.eDeliveryService.stateCopyOfAccounts[i].externalEmailAddr;
                                    this.trackProxyChanges(myEvent);
                                } else if (docNew.edocumentType.docTypeCd === 'PROS') {
                                    this.selectedEmail = this.eDeliveryService.stateCopyOfAccounts[i].externalEmailAddr;
                                    // if (docPrevious.preferenceType.deliveryPreference !== 4) {
                                    this.trackProspectusChanges(myEvent);
                                    // }
                                } else {
                                    // Need specific values for Notif and QPR since they are reversed in order when displaying
                                    // if (docPrevious.preferenceType.deliveryPreference !== 4) {
                                    if (j === 2) {
                                        this.trackListOfDocs(myEvent, 4);
                                    } else if (j === 4) {
                                        this.trackListOfDocs(myEvent, 2);
                                    } else {
                                        this.trackListOfDocs(myEvent, j);
                                    }
                                    // }
                                }
                            }
                        }
                    }
                }
                let positionInAccountsArray = this.findAccountInArray();
                if (positionInAccountsArray !== -1) { // If it finds it:
                    if (this.eDeliveryService.accountsWithChangedEmails[positionInAccountsArray].externalEmailAddr !== this.selectedEmail) {
                        this.selectedEmail = this.eDeliveryService.accountsWithChangedEmails[positionInAccountsArray].externalEmailAddr;
                        // this.changeEmail();
                        this.emailChanged = true;
                        this.enableOrDisableSaveButton();
                    }
                }
            } else {
                this.eDeliveryService.firstCellAccount = false;
            }
        }
    }

    isAccountPendingEnrollment() {
        for (let i = 0; i < this.params.edeliveryDocuments.length; i++) {
            if (this.isDocumentPending(this.params.edeliveryDocuments[i].edocumentType.docTypeDesc)) {
                // Add to list of changed accounts so that when enrolling,
                // we are able to track accounts that are pending enrollment and had no action taken on them (checking/unchecking any box)
                this.params.externalEmailAddr = this.selectedEmail;
                this.eDeliveryService.addChangedAccount(this.params);
            }
        }
    }

    // Check if included to enable hyperlink
    isDocIncluded(document) {
        let correctDocumentName = this.returnCorrespondingName(document);
        if (correctDocumentName !== 'Statements and Reports' && correctDocumentName !== 'Trade Confirmations' && correctDocumentName !== 'Proxy/Shareholder Communications') {
            return true;
        }
    }

    isDocumentEnrolled(documentName) {
        const docs = this.params.edeliveryDocuments;
        let correctDocumentName = this.returnCorrespondingName(documentName);
        for (const document of docs) {
            if (document.edocumentType.docTypeDesc === correctDocumentName) {
                if (document.preferenceType.deliveryPreference === 2) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    isDocumentPending(documentName) {
        if (this.eDeliveryService.originalResponse !== undefined) {
            for (let i = 0; i < this.eDeliveryService.originalResponse.accounts.length; i++) {
                if (this.eDeliveryService.originalResponse.accounts[i].accountNumber === this.params.accountNumber) {
                    const docs = this.eDeliveryService.originalResponse.accounts[i].edeliveryDocuments;
                    let correctDocumentName = this.returnCorrespondingName(documentName);
                    for (let j = 0; j < docs.length; j++) {
                        let document = docs[j];
                        if (document.edocumentType.docTypeDesc === correctDocumentName) {
                            if (document.preferenceType.deliveryPreference === 4) {
                                // this.eDeliveryService.documentsPending = true;
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                }
            }
        } else {
            const docs = this.originalAccount.edeliveryDocuments;
            let correctDocumentName = this.returnCorrespondingName(documentName);
            for (let i = 0; i < docs.length; i++) {
                let document = docs[i];
                if (document.edocumentType.docTypeDesc === correctDocumentName) {
                    if (document.preferenceType.deliveryPreference === 4) {
                        // this.eDeliveryService.documentsPending = true;
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
    }

    isDocEligible(documentName) {
        const docs = this.params.edeliveryDocuments;
        let correctDocumentName = this.returnCorrespondingName(documentName);
        for (const document of docs) {
            if (document.edocumentType.docTypeDesc === correctDocumentName) {
                if (document.docEligible) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    getEffectiveDate(documentName) {
        const docs = this.params.edeliveryDocuments;
        let correctDocumentName = this.returnCorrespondingName(documentName);
        for (const document of docs) {
            if (document.edocumentType.docTypeDesc === correctDocumentName) {
                 return document.effectiveDate;
            }
        }
    }

    returnCorrespondingName(label) {
        if (label === this.statementsLabel) {
            return 'Statements and Reports';
        } else if (label === this.tradeLabel) {
            return 'Trade Confirmations';
        } else if (label === this.notificationsLabel) {
            return 'Notifications';
        } else if (label === this.taxLabel) {
            return 'Tax Documents';
        } else if (label === this.QPRLabel) {
            return 'Quarterly Performance Reports';
        } else if (label === this.prospectusLabel) {
            return 'Prospectus';
        } else if (label === this.proxyLabel) {
            return 'Proxy/Shareholder Communications';
        } else {
            return label;
        }
        // this.allDocumentNames = ['Statements and Reports', 'Trade Confirmations', 'Notifications', 'Tax Documents', 'Quarterly Performance Reports'];
    }

    // Create a checking list of currently enrolled documents
    createListOfDocuments() {
        const docs = this.params.edeliveryDocuments;
        for (const document of docs) {
            if ((document.preferenceType.deliveryPreference === 2 || document.preferenceType.deliveryPreference === 4) && document.docEligible) {
                this.listOfEnrolledDocuments.push(document.edocumentType.docTypeDesc);                
            }
            if (document.edocumentType.docType < 6 && document.docEligible !== false) {
                this.pershingDocNames.push(document.edocumentType.docTypeDesc);
            } else {
                if (document.docEligible !== false) {
                    if (document.edocumentType.docTypeDesc === 'Prospectus') {
                        this.albridgeDocNames.push(this.prospectusLabel);
                    } else if (document.edocumentType.docTypeDesc === 'Proxy/Shareholder Communications') {
                        this.albridgeDocNames.push(this.proxyLabel);
                    }
                }
            }
        }
        // Revert order of albridge documents since they display in reverse order.
        if (this.albridgeDocNames.length > 1) {
            let proxy = this.albridgeDocNames[0];
            let prospectus = this.albridgeDocNames[1];
            this.albridgeDocNames[0] = prospectus;
            this.albridgeDocNames[1] = proxy;
        }
    }

    limitEventPropagation($event) {
        if ($event.code === 'ArrowDown') {
            $event.stopPropagation();
        } else if ($event.code === 'ArrowUp') {
            $event.stopPropagation();
        }
    }

    // Might need later
    // addPendingDocsToFinalList() {
    //     this.pendingAccount = JSON.parse(JSON.stringify(this.params));
    //     let isAccountPendingEnrollment = false;
    //     const docs = this.pendingAccount.edeliveryDocuments;
    //     for (let i = 0; i < docs.length; i++) {
    //         let document = docs[i];
    //         if (document.preferenceType.deliveryPreference === 4) {
    //             // Create a copy of the account inside enroll.component.ts and submit it with these preferences
    //             isAccountPendingEnrollment = true;
    //             this.pendingAccount.edeliveryDocuments[i].preferenceType.deliveryPreference = 2;
    //             this.pendingAccount.edeliveryDocuments[i].preferenceType.preferenceCode = 'ONLINE';
    //             this.pendingAccount.edeliveryDocuments[i].preferenceType.preferenceCodeMF = 'E';
    //             if (document.edocumentType.docTypeCd === 'PRXY') {
    //                 this.pendingAccount.externalEmailAddr = this.selectedEmail;

    //             }
    //         }
    //     }
    //     if (isAccountPendingEnrollment) {
    //         this.eDeliveryService.addChangedAccount(this.pendingAccount);
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }

    retrieveDocsIncluded(document) {
        this.docsIncluded = [];
        let correctDocumentName = this.returnCorrespondingName(document);
        if (correctDocumentName === 'Notifications') {
            this.eDeliveryService.retrieveDocInclusion(3);
        } else if (correctDocumentName === 'Tax Documents') {
            this.eDeliveryService.retrieveDocInclusion(4);
        } else if (correctDocumentName === 'Quarterly Performance Reports') {
            this.docsIncluded = this.params.edeliveryDocuments[2].documentsIncluded;
        } else if (correctDocumentName === 'Prospectus') {
            this.docsIncluded = this.params.edeliveryDocuments[6].documentsIncluded;
        } else {
            this.docsIncluded = [];
        }
        this.showDocsIncluded = !this.showDocsIncluded;
    }

    isChecked(index): boolean {
        let correctDocumentName = this.returnCorrespondingName(this.allDocumentNames[index]);
        if (this.listOfEnrolledDocuments.indexOf(correctDocumentName) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    isProspectusChecked(): boolean {
        if (this.listOfEnrolledDocuments.indexOf('Prospectus') >= 0) {
            this.prospectusChecked = true;
            return true;
        } else {
            this.prospectusChecked = false;
            return false;
        }
    }

    isProxyChecked(): boolean {
        let deliveryPreference = this.params.edeliveryDocuments[5].preferenceType.deliveryPreference;
        if (deliveryPreference === 2 || deliveryPreference === 4) {
            this.proxyChecked = true;
            return true;
        } else {
            this.proxyChecked = false;
            return false;
        }
    }

    isEmailDisabled(): boolean {
        if (!this.isProspectusChecked() && !this.isProxyChecked()) {
            this.disableEmail = true;
            return true;
        } else {
            this.disableEmail = false;
            return false;
        }
    }

    trackListOfDocs($event, index): void {
        this.testCount++;
        this.testAccount = this.params;
        // Find the actual index:
        let trueIndex = this.findRespectiveNameIndex(index);
        let preferenceType = this.testAccount.edeliveryDocuments[trueIndex].preferenceType;
        if ($event.checked === false) {
            preferenceType.deliveryPreference = 1;
            preferenceType.preferenceCode = 'PAPER';
            preferenceType.preferenceCodeMF = 'P';
        } else {
            if (!this.eDeliveryService.isNXIRequest() && this.originalAccount.edeliveryDocuments[trueIndex].preferenceType.deliveryPreference === 4) {
                preferenceType.deliveryPreference = 4;
                preferenceType.preferenceCode = 'PENDING';
                preferenceType.preferenceCodeMF = 'N';
            } else {
                preferenceType.deliveryPreference = 2;
                preferenceType.preferenceCode = 'ONLINE';
                preferenceType.preferenceCodeMF = 'E';
            }
        }
        this.eDeliveryService.addChangedAccount(this.testAccount);

        this.enableOrDisableSaveButton();

        //
        // Need to refactor this piece code to fit quickEnroll's setup. (this is for the tracking list)
        //
        for (let i = 0; i < this.eDeliveryService.trackingList.length; i++) {
            let documentPreference = this.eDeliveryService.trackingList[i].edeliveryDocuments[trueIndex].preferenceType;
            let accountNumber = this.eDeliveryService.trackingList[i].accountNumber;
            // Call a function (do this for the other cases as well)
            this.assignTrackingPreferences(accountNumber, documentPreference, $event.checked);
        }
    }

    trackProspectusChanges($event): void {
        this.testAccount = this.params;
        this.warning.warningMessage = '';
        this.displayWarning = false;
        this.warningMessage = '';
        let preferenceType = this.testAccount.edeliveryDocuments[6].preferenceType;
        if ($event.checked) { // Then checkbox was checked
            if (!this.eDeliveryService.isNXIRequest() && this.originalAccount.edeliveryDocuments[6].preferenceType.deliveryPreference === 4) {
                preferenceType.deliveryPreference = 4;
                preferenceType.preferenceCode = 'PENDING';
                preferenceType.preferenceCodeMF = 'N';
                this.testAccount.externalEmailAddr = this.selectedEmail;
                this.disableEmail = false;
                this.prospectusChecked = true;
            } else {
                preferenceType.deliveryPreference = 2;
                preferenceType.preferenceCode = 'ONLINE';
                preferenceType.preferenceCodeMF = 'E';
                this.testAccount.externalEmailAddr = this.selectedEmail;
                this.disableEmail = false;
                this.prospectusChecked = true;
            }
        } else { // Then checkbox was unchecked
            preferenceType.deliveryPreference = 1;
            preferenceType.preferenceCode = 'PAPER';
            preferenceType.preferenceCodeMF = 'P';
            this.prospectusChecked = false;
            if (!this.proxyChecked) {
                this.disableEmail = true;
            }
        }
        this.eDeliveryService.addChangedAccount(this.testAccount);

        this.enableOrDisableSaveButton();

        //
        // Need to refactor this piece code to fit quickEnroll's setup. (this is for the tracking list)
        //
        for (let i = 0; i < this.eDeliveryService.trackingList.length; i++) {
            let documentPreference = this.eDeliveryService.trackingList[i].edeliveryDocuments[6].preferenceType;
            let accountNumber = this.eDeliveryService.trackingList[i].accountNumber;
            if (accountNumber === this.testAccount.accountNumber) {
                this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
            }
            // Call a function (do this for the other cases as well)
            this.assignTrackingPreferences(accountNumber, documentPreference, $event.checked);
        }
    }

    trackProxyChanges($event): void {
        this.testAccount = this.params;
        this.warning.warningMessage = '';
        this.displayWarning = false;
        this.warningMessage = '';
        let preferenceType = this.testAccount.edeliveryDocuments[5].preferenceType;
        if ($event.checked) { // Then checkbox was checked
            if (!this.eDeliveryService.isNXIRequest() && this.originalAccount.edeliveryDocuments[5].preferenceType.deliveryPreference === 4) {
                preferenceType.deliveryPreference = 4;
                preferenceType.preferenceCode = 'PENDING';
                preferenceType.preferenceCodeMF = 'N';
                this.testAccount.externalEmailAddr = this.selectedEmail;
                this.proxyChecked = true;
                this.disableEmail = false;
                // Trigger observable for re rendering row
                setTimeout(() => {
                    this.eDeliveryService.triggerRowUpdate(true);
                }, 0);
            } else {
                preferenceType.deliveryPreference = 2;
                preferenceType.preferenceCode = 'ONLINE';
                preferenceType.preferenceCodeMF = 'E';
                this.testAccount.externalEmailAddr = this.selectedEmail;
                this.proxyChecked = true;
                this.disableEmail = false;
                // Trigger observable for re rendering row
                setTimeout(() => {
                    this.eDeliveryService.triggerRowUpdate(true);
                }, 0);
            }
        } else { // Then checkbox was unchecked
            preferenceType.deliveryPreference = 1;
            preferenceType.preferenceCode = 'PAPER';
            preferenceType.preferenceCodeMF = 'P';
            this.proxyChecked = false;
            // Trigger observable for re rendering row
            setTimeout(() => {
                this.eDeliveryService.triggerRowUpdate(false);
            }, 0);
            // Disable email box based on whether both proxy and prospectus are unchecked
            if (!this.prospectusChecked) {
                this.disableEmail = true;
            }
        }
        this.eDeliveryService.addChangedAccount(this.testAccount);

        this.enableOrDisableSaveButton();
        //
        // Need to refactor this piece code to fit quickEnroll's setup. (this is for the tracking list)
        //
        for (let i = 0; i < this.eDeliveryService.trackingList.length; i++) {
            let documentPreference = this.eDeliveryService.trackingList[i].edeliveryDocuments[5].preferenceType;
            let accountNumber = this.eDeliveryService.trackingList[i].accountNumber;
            if (accountNumber === this.testAccount.accountNumber) {
                this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
            }
            // Call a function (do this for the other cases as well)
            this.assignTrackingPreferences(accountNumber, documentPreference, $event.checked);
        }
    }

    enableOrDisableSaveButton() {
        let tempMap = this.eDeliveryService.accountsChangedMap;
        let disable = true;
        if (this.werePreferencesChanged()) {
            tempMap.set(this.params.accountNumber, true);
        } else {
            tempMap.set(this.params.accountNumber, false);
        }
        tempMap.forEach((value: boolean, key: string) => {
            if (value) { // If true, then enable button
                disable = false;
            }
        });

        if (disable) {
            this.eDeliveryService.disableEnrollButtonInEdit(true);
        } else {
            this.eDeliveryService.disableEnrollButtonInEdit(false);
        }
    }

    werePreferencesChanged() {
        let originalAccountFromService;
        let tempOriginalAccountPreferenceType;
        // Do a for loop which checks all of the documents to see if there are any that have changed.
        let documents = this.params.edeliveryDocuments;
        if (this.eDeliveryService.originalResponse !== undefined) {
            for (let i = 0; i < this.eDeliveryService.originalResponse.accounts.length; i++) {
                if (this.eDeliveryService.originalResponse.accounts[i].accountNumber === this.params.accountNumber) {
                    originalAccountFromService = this.eDeliveryService.originalResponse.accounts[i];
                    break;
                }
            }
        }
        for (let i = 0; i < documents.length; i++) {
            let tempTestAccountPreferenceType = documents[i].preferenceType;
            if (originalAccountFromService !== undefined) {
                tempOriginalAccountPreferenceType = originalAccountFromService.edeliveryDocuments[i].preferenceType;
            } else {
                tempOriginalAccountPreferenceType = this.originalAccount.edeliveryDocuments[i].preferenceType;
            }
            // let tempOriginalAccountPreferenceType = this.originalAccount.edeliveryDocuments[i].preferenceType;
            if (tempTestAccountPreferenceType.deliveryPreference !== tempOriginalAccountPreferenceType.deliveryPreference || this.emailChanged) {
                return true;
            }
            if (i === documents.length - 1) {
                return false;
            }
        }
    }

    findRespectiveNameIndex(index): number {
        for (let i = 0; i < this.testAccount.edeliveryDocuments.length; i++) {
            let value = this.allDocumentNames[index];
            let correctDocumentName = this.returnCorrespondingName(value);
            if (this.testAccount.edeliveryDocuments[i].edocumentType.docTypeDesc === correctDocumentName) {
                return i;
            }
        }
    }

    assignTrackingPreferences(accountNumber, documentPreference, flag): void {
        if (accountNumber === this.testAccount.accountNumber) {
            if (flag) { // true
                if (!this.eDeliveryService.isNXIRequest() && documentPreference.deliveryPreference === 4) {
                    documentPreference.deliveryPreference = 4;
                    documentPreference.preferenceCode = 'PENDING';
                    documentPreference.preferenceCodeMF = 'N';
                } else {
                    documentPreference.deliveryPreference = 2;
                    documentPreference.preferenceCode = 'ONLINE';
                    documentPreference.preferenceCodeMF = 'E';
                }
            } else { // false / makes sure that a account doesn't get de-enrolled by mistake.
                documentPreference.deliveryPreference = 1;
                documentPreference.preferenceCode = 'PAPER';
                documentPreference.preferenceCodeMF = 'P';
            }
        }
    }

    changeEmail() {
        this.params.externalEmailAddr = this.selectedEmail;
        for (let i = 0; i < this.eDeliveryService.trackingList.length; i++) {
            if (this.eDeliveryService.trackingList[i].accountNumber === this.params.accountNumber) {
                this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
            }
        }

        if (this.originalAccount.externalEmailAddr !== this.selectedEmail) {
            this.emailChanged = true;
        } else {
            this.emailChanged = false;
        }

        if (this.pendingAccount !== undefined) {
            if (this.originalAccount.edeliveryDocuments[5].preferenceType.deliveryPreference === 4 ||
                this.originalAccount.edeliveryDocuments[6].preferenceType.deliveryPreference === 4) {
                    this.pendingAccount.externalEmailAddr = this.selectedEmail;
                    this.eDeliveryService.addChangedAccount(this.pendingAccount);
                    // return;
            }
        }
        this.enableOrDisableSaveButton();
        // Need to verify it is not the first time enrolling in proxy/prospectus
        if (this.originalAccount.edeliveryDocuments[6].docEligible === true) {
            if (this.originalAccount.edeliveryDocuments[5].preferenceType.deliveryPreference !== 1 &&
                this.originalAccount.edeliveryDocuments[6].preferenceType.deliveryPreference !== 1) {

                let proxy;
                let prospectus;
                let tempAccountCopy;
                if (this.eDeliveryService.accountsWithChangedEmails.length > 0) {
                    // Find if account is already in array:
                    let positionInAccountsArray = this.findAccountInArray();
                    if (positionInAccountsArray !== -1) { // If it finds it:
                        if (this.eDeliveryService.accountsWithChangedEmails[positionInAccountsArray].externalEmailAddr !== this.selectedEmail) {
                            this.eDeliveryService.accountsWithChangedEmails.splice(positionInAccountsArray, 1);
                        }
                    } else {
                        proxy = this.params.edeliveryDocuments[5];
                        prospectus = this.params.edeliveryDocuments[6];
                        tempAccountCopy = JSON.parse(JSON.stringify(this.params));
                        tempAccountCopy.edeliveryDocuments = [];
                        tempAccountCopy.edeliveryDocuments.push(proxy);
                        tempAccountCopy.edeliveryDocuments.push(prospectus);
                        this.eDeliveryService.accountsWithChangedEmails.push(tempAccountCopy);
                    }
                } else { // Insert into array of accounts with changed emails
                    proxy = this.params.edeliveryDocuments[5];
                    prospectus = this.params.edeliveryDocuments[6];
                    tempAccountCopy = JSON.parse(JSON.stringify(this.params));
                    tempAccountCopy.edeliveryDocuments = [];
                    tempAccountCopy.edeliveryDocuments.push(proxy);
                    tempAccountCopy.edeliveryDocuments.push(prospectus);
                    this.eDeliveryService.accountsWithChangedEmails.push(tempAccountCopy);
                }
            } else {
                if (this.originalAccount.edeliveryDocuments[5].preferenceType.deliveryPreference !== 1) {
                    this.assignPreferencesAndEmail(5);
                }
                if (this.originalAccount.edeliveryDocuments[6].preferenceType.deliveryPreference !== 1) {
                    this.assignPreferencesAndEmail(6);
                }
            }
        } else {
            if (this.originalAccount.edeliveryDocuments[5].preferenceType.deliveryPreference !== 1) {
                this.assignPreferencesAndEmail(5);
            }
        }
    }

    findAccountInArray() {
        for (let i = 0; i < this.eDeliveryService.accountsWithChangedEmails.length; i++) {
            if (this.eDeliveryService.accountsWithChangedEmails[i].accountNumber === this.params.accountNumber) {
                return i;
            }
        }
        return -1;
    }

    // Assign preferences and email for either proxy or prospectus
    assignPreferencesAndEmail(index) {
        let proxyOrProspectusDocument;
        let tempAccountCopy;
        if (this.eDeliveryService.accountsWithChangedEmails.length > 0) {
            for (let j = 0; j < this.eDeliveryService.accountsWithChangedEmails.length; j++) {
                // Only change email address back in case the user changes their mind
                // Find if account is already in array:
                let positionInAccountsArray = this.findAccountInArray();
                if (positionInAccountsArray !== -1) { // If it finds it:
                    this.eDeliveryService.accountsWithChangedEmails[positionInAccountsArray].externalEmailAddr = this.selectedEmail;
                    this.eDeliveryService.accountsWithChangedEmails.splice(positionInAccountsArray, 1);
                    break;
                } else {
                    proxyOrProspectusDocument = this.params.edeliveryDocuments[index];
                    tempAccountCopy = JSON.parse(JSON.stringify(this.params));
                    tempAccountCopy.edeliveryDocuments = [];
                    tempAccountCopy.edeliveryDocuments.push(proxyOrProspectusDocument);
                    this.eDeliveryService.accountsWithChangedEmails.push(tempAccountCopy);
                    break;
                }
            }
        } else { // Insert into array of accounts with changed emails
            proxyOrProspectusDocument = this.params.edeliveryDocuments[index];
            tempAccountCopy = JSON.parse(JSON.stringify(this.params));
            tempAccountCopy.edeliveryDocuments = [];
            tempAccountCopy.edeliveryDocuments.push(proxyOrProspectusDocument);
            this.eDeliveryService.accountsWithChangedEmails.push(tempAccountCopy);
        }
    }

    emailBelongsToID(currentEmailAddress) {
        for (let i = 0; i < this.userEmails.length; i++) {
            if (this.userEmails[i].emailAddress === currentEmailAddress) {
                return true;
            }
        }
        return false;
    }
}
